import { createRouter, createWebHistory } from "vue-router";

import CandidateChildren from "./certipers/Candidatchildren";
import Reviewerchildren from "./certipers/Reviewerchildren";
import Adminchildren from "./certipers/AdministrationChildren";
import CertipersPublicChildren from "./certipers-public/children";

import { useMainStore } from "@/store/index";
import getOidcUser from "@/router/middleware/getOidcUser";
import redirectByUserRole from "@/router/middleware/redirectByUserRole";
import verifyUserRole from "@/router/middleware/verifyUserRole";
import { useAuth, useOidcStore } from "vue3-oidc";

const OidcCallback = () =>
  import(/* webpackChunkName: "OidcCallback" */ "@/components/OidcCallback.vue");
const CERTIPERSCandidat = () =>
  import(/* webpackChunkName: "CERTIPERSCandidat" */ "@/components/CERTIPERSCandidat.vue");

const CERTIPERSReviewer = () =>
  import(/* webpackChunkName: "CERTIPERSReviewer" */ "@/components/CERTIPERSReviewer.vue");

const CERTIPERSAdmin = () =>
  import(/* webpackChunkName: "CERTIPERSAdmin" */ "@/components/CERTIPERSAdmin.vue");

const CERTIPERSPublic = () =>
  import(/* webpackChunkName: "CERTIPERSPublic" */ "@/components/CERTIPERSPublic.vue");

const routes = [
  {
    path: "/",
    name: "login",
    component: CERTIPERSPublic,
    children: CertipersPublicChildren,
    meta: {
      isPublic: true,
    },
    beforeEnter: async (to, from, next) => {
      const mainStore = useMainStore();
      const oidcStore = useOidcStore();
      getOidcUser(oidcStore)(to, from, next);
      await mainStore.publicFetch();
      next();
    },
  },
  {
    path: "/redirection",
    name: "redirection",
    beforeEnter: redirectByUserRole(),
  },
  {
    path: "/candidate",
    component: CERTIPERSCandidat,
    children: CandidateChildren,
    beforeEnter: verifyUserRole("candidate"),
  },
  {
    path: "/reviewer",
    component: CERTIPERSReviewer,
    children: Reviewerchildren,
    beforeEnter: verifyUserRole("reviewer"),
  },
  {
    path: "/admin",
    component: CERTIPERSAdmin,
    children: Adminchildren,
    beforeEnter: verifyUserRole("admin"),
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in your oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/redirection",
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }
  const { signinRedirect } = useAuth();
  const oidcStore = useOidcStore();
  const userManager = oidcStore.state.value?.userManager;
  let user = oidcStore.state.value.user;
  // If user is not set, try to get it from the userManager
  if (!user && userManager) {
    user = await userManager.getUser();
    if (user) {
      oidcStore.actions.value.setUser(user);
    }
  }
  if (!user && !to.meta.isPublic) {
    signinRedirect({ state: { redirectPath: to.fullPath } });
    return next(false);
  }
  next();
});

export default router;
